/** This file is auto generated. Run `npm run deprecate props` */
export default {
  Accordion: {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  'Accordion.Item': {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  Alert: {
    ariaLabelledby: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    },
    ariaDescribedby: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Box: {
    isBordered: {
      deprecated: '2.52.0',
      remove: '2.62.0'
    }
  },
  ButtonGroup: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Button: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Callout: {
    type: {
      deprecated: '2.57.0',
      remove: '2.67.0'
    }
  },
  DefinitionListTable: {
    isBorderless: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  Dropdown: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  FilePicker: {
    ariaDescribedBy: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  FormOption: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Link: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    },
    ariaLabelledby: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Masthead: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  'Menu.Link': {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Menu: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  MultiSelect: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Pagination: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  SelectablePanelGroup: {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  SelectablePanel: {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  Slab: {
    text: {
      deprecated: '2.54.0',
      remove: '2.64.0'
    },
    hasArrow: {
      deprecated: '2.62.0',
      remove: '2.72.0'
    }
  },
  Slider: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Switch: {
    ariaLabel: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    },
    ariaDescribedBy: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  },
  Table: {
    isBorderless: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  Tabs: {
    bordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  'Tile.Body': {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  'Tile.Head': {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  Tile: {
    isBordered: {
      deprecated: '2.55.0',
      remove: '2.65.0'
    }
  },
  VehicleImage: {
    ariaLabelledby: {
      deprecated: '2.56.0',
      remove: '2.66.0'
    }
  }
};